import React from 'react';
import classnames from 'classnames';
import { LoaderDots, IconArrowLeft } from '../../index';
export const PageContainer = ({
  children,
  className,
  shadowDistance
}) => /*#__PURE__*/React.createElement("div", {
  className: classnames(className, 'page', `shadow-${shadowDistance}`)
}, children);
export const PageHeader = ({
  children
}) => /*#__PURE__*/React.createElement("div", {
  className: "page__header"
}, children);
export const PageHeaderArrow = () => /*#__PURE__*/React.createElement("div", {
  className: "page__header-arrow"
}, /*#__PURE__*/React.createElement(IconArrowLeft, {
  color: "black",
  size: 13
}));
export const PageTitle = ({
  children
}) => /*#__PURE__*/React.createElement("div", {
  className: "page__title"
}, children);
export const PageSubTitle = ({
  children
}) => /*#__PURE__*/React.createElement("div", {
  className: "page__sub-title"
}, children);
export const PageView = ({
  children,
  isLoading = false,
  className,
  shadowDistance
}) => /*#__PURE__*/React.createElement("div", {
  className: classnames(className, 'page__view', `shadow-${shadowDistance}`)
}, isLoading ? /*#__PURE__*/React.createElement("div", {
  className: "page__loading"
}, /*#__PURE__*/React.createElement(LoaderDots, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, children));
export const PageSidebar = ({
  children,
  style = {}
}) => /*#__PURE__*/React.createElement("div", {
  className: "page__sidebar",
  style: { ...style
  }
}, children);
export const PageSidebarHeader = ({
  children
}) => /*#__PURE__*/React.createElement("div", {
  className: "page__sidebar__header"
}, children);
export const PageSidebarMenu = ({
  children
}) => /*#__PURE__*/React.createElement("div", {
  className: "page__sidebar__menu"
}, children);